import { PageHeader } from "@/components/layout/PageHeader";
import { EventCard } from "@/components/events/EventCard";
import { usePendingEvents } from "@/hooks/useEvents";
import { useCategories } from "@/hooks/useCategories";

export default function PendingEventsPage() {
  const { data: events, isLoading, error } = usePendingEvents();
  const { data: categories = [] } = useCategories();

  return (
    <div>
      <PageHeader
        title="Oczekujące na moderację"
        description="Zatwierdź lub odrzuć zgłoszone wydarzenia"
      />
      {isLoading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-80 rounded-lg bg-slate-100 animate-pulse" />
          ))}
        </div>
      )}
      {error && <p className="text-destructive">Błąd ładowania: {error.message}</p>}
      {!isLoading && !error && events && events.length === 0 && (
        <div className="text-center py-16 text-muted-foreground">
          <p className="text-lg">Brak oczekujących wydarzeń</p>
          <p className="text-sm mt-1">Wszystkie zgłoszenia zostały rozpatrzone.</p>
        </div>
      )}
      {!isLoading && events && events.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {events.map((event) => (
            <EventCard key={event.id} event={event} categories={categories} />
          ))}
        </div>
      )}
    </div>
  );
}
